/* T-Nerds — Theme-Skript: Menü, Suche, Warenkorb-Drawer, Mengen, Akkordeon. */
(function () {
  'use strict';
  var R = window.tnRoutes || {};
  var money = function (cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR' });
  };

  /* ---------- Mobiles Menü ---------- */
  function initBurger() {
    var btn = document.querySelector('[data-tn-burger]');
    var nav = document.getElementById('tn-mobilenav');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      var open = !nav.hidden;
      nav.hidden = open;
      btn.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ---------- Predictive Search ---------- */
  function initSearch() {
    var form = document.querySelector('[data-tn-search]');
    if (!form) return;
    var input = form.querySelector('input[name=q]');
    var box = form.querySelector('[data-tn-suggest]');
    var timer, controller;
    function close() { box.hidden = true; box.innerHTML = ''; }
    function render(items) {
      if (!items.length) { box.innerHTML = '<p class="tn-suggest__empty">Nichts gefunden. Probier einen anderen Begriff.</p>'; box.hidden = false; return; }
      box.innerHTML = items.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=120" alt="" loading="lazy">' : '';
        return '<a class="tn-suggest__item" href="' + p.url + '">' +
          '<span class="tn-suggest__art">' + img + '</span>' +
          '<span class="tn-suggest__title">' + p.title + '</span>' +
          '<span class="tn-suggest__price">' + money(p.price) + '</span></a>';
      }).join('');
      box.hidden = false;
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = (R.predictive || '/search/suggest.json') + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.json(); })
          .then(function (d) { render((d.resources && d.resources.results && d.resources.results.products) || []); })
          .catch(function () {});
      }, 220);
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); input.blur(); } });
  }

  /* ---------- Warenkorb ---------- */
  function cartFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function setCount(n) {
    document.querySelectorAll('[data-tn-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }
  function drawerLines(cart) {
    if (!cart.item_count) return '<p class="tn-empty">Noch nichts drin. Zeit, ein Motiv auszusuchen.</p>';
    return '<div class="tn-lines">' + cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" loading="lazy">' : '';
      var meta = it.options_with_values ? it.options_with_values.map(function (o) { return o.value; }).join(' · ') : '';
      return '<div class="tn-line" data-tn-key="' + it.key + '">' +
        '<span class="tn-line__media">' + img + '</span>' +
        '<div><a class="tn-line__title" href="' + it.url + '">' + it.product_title + '</a>' +
        '<p class="tn-line__meta">' + meta + ' · ' + it.quantity + '&nbsp;&times; ' + money(it.final_price) + '</p>' +
        '<button type="button" class="tn-line__remove" data-tn-remove="' + it.key + '">Entfernen</button></div>' +
        '</div>';
    }).join('') + '</div>' +
      '<div class="tn-drawer__foot"><div class="tn-summary__total"><span>Zwischensumme</span><span>' + money(cart.total_price) + '</span></div>' +
      '<a class="tn-btn tn-btn--block" href="' + (R.cart || '/cart') + '">Warenkorb ansehen</a>' +
      '<form action="' + (R.cart || '/cart') + '" method="post"><button type="submit" name="checkout" class="tn-btn tn-btn--ghost tn-btn--block" style="margin-top:10px">Direkt zur Kasse</button></form></div>';
  }
  function openDrawer(cart) {
    var d = document.getElementById('tn-cart-drawer');
    if (!d) return;
    d.querySelector('[data-tn-drawer-body]').innerHTML = drawerLines(cart);
    d.hidden = false;
    document.body.style.overflow = 'hidden';
    var close = d.querySelector('[data-tn-close]');
    if (close) close.focus();
  }
  function closeDrawer() {
    var d = document.getElementById('tn-cart-drawer');
    if (!d) return;
    d.hidden = true;
    document.body.style.overflow = '';
  }
  function refreshCartSections() {
    var host = document.getElementById('tn-cart-progress');
    if (!host) return;
    fetch((R.root || '/') + '?section_id=tn-cart-progress')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('tn-cart-progress');
        if (fresh) host.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function initCart() {
    var drawerOn = document.body.dataset.tnDrawer === 'true';
    document.addEventListener('click', function (e) {
      var close = e.target.closest('[data-tn-close]');
      if (close) { closeDrawer(); return; }
      var open = e.target.closest('[data-tn-open-cart]');
      if (open && drawerOn) {
        e.preventDefault();
        fetch((R.root || '/') + 'cart.js').then(function (r) { return r.json(); }).then(openDrawer);
        return;
      }
      var rm = e.target.closest('[data-tn-remove]');
      if (rm) {
        e.preventDefault();
        var upd = {};
        upd[rm.getAttribute('data-tn-remove')] = 0;
        cartFetch((R.cart || '/cart') + '/update.js', { updates: upd }).then(function (cart) {
          setCount(cart.item_count);
          if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
          var d = document.getElementById('tn-cart-drawer');
          if (d && !d.hidden) d.querySelector('[data-tn-drawer-body]').innerHTML = drawerLines(cart);
          refreshCartSections();
        });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    /* Produktformular per AJAX */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-tn-add]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Moment …'; }
      fetch((R.cartAdd || '/cart/add') + '.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch((R.root || '/') + 'cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          setCount(cart.item_count);
          if (btn) { btn.textContent = 'Im Warenkorb ✓'; setTimeout(function () { btn.textContent = label; btn.removeAttribute('aria-disabled'); }, 1600); }
          if (drawerOn) openDrawer(cart);
          refreshCartSections();
        })
        .catch(function () {
          if (btn) { btn.textContent = label; btn.removeAttribute('aria-disabled'); }
          form.submit();
        });
    });
  }

  /* ---------- Mengen-Stepper ---------- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tn-step]');
      if (!b) return;
      var wrap = b.closest('.tn-qty');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var min = parseInt(input.min || '1', 10);
      var next = (parseInt(input.value, 10) || min) + parseInt(b.getAttribute('data-tn-step'), 10);
      input.value = Math.max(min, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    /* Cart-Seite: Änderung direkt speichern */
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-tn-line-qty]');
      if (!input) return;
      var form = input.closest('form');
      if (form) form.submit();
    });
  }

  function boot() { initBurger(); initSearch(); initCart(); initQty(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
